export default __webpack_public_path__ + "static/media/upload.fb4e3624.svg";